import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Shield, Zap, Headset } from 'lucide-react';
import VideoBackground from './VideoBackground';

const Hero = ({ onGetQuote }) => {
  // Your custom data center video
  const serverVideoUrl = "https://customer-assets.emergentagent.com/job_corporate-connect-18/artifacts/1d57v8s1_video_20260331_181927.webm";
  const fallbackImage = "https://images.pexels.com/photos/4508751/pexels-photo-4508751.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden">
      {/* Video Background - More Visible */}
      <VideoBackground 
        videoUrl={serverVideoUrl} 
        fallbackImage={fallbackImage}
      />
      
      {/* Lighter overlay for better video visibility */}
      <div className="absolute inset-0 bg-gradient-to-r from-slate-900/70 via-slate-900/60 to-slate-900/50 z-0"></div>
      
      {/* Subtle grid overlay */}
      <div className="absolute inset-0 opacity-5 z-0">
        <div 
          className="h-full w-full"
          style={{
            backgroundImage: `
              linear-gradient(rgba(16, 185, 129, 0.2) 1px, transparent 1px),
              linear-gradient(90deg, rgba(16, 185, 129, 0.2) 1px, transparent 1px)
            `,
            backgroundSize: '50px 50px',
            animation: 'grid-scroll 20s linear infinite'
          }}
        />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-3xl animate-slide-in-bottom">
          <div className="inline-flex items-center gap-2 bg-emerald-500/20 border border-emerald-500/30 rounded-full px-4 py-2 mb-6 backdrop-blur-md">
            <Shield className="w-4 h-4 text-emerald-400 animate-float" />
            <span className="text-sm text-emerald-400 font-medium">Tech360 Technologies</span>
          </div>
          
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight drop-shadow-lg">
            Advanced Technology &
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 via-cyan-400 to-emerald-400 animate-gradient drop-shadow-lg">
              Automation Solutions
            </span>
          </h1>
          
          <p className="text-xl text-gray-200 mb-8 leading-relaxed max-w-2xl drop-shadow-md">
            Professional server rack installation, network setup, IoT automation, and enterprise-grade internet services for modern businesses.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <Button 
              size="lg" 
              onClick={onGetQuote}
              className="bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-cyan-600 text-white px-8 py-6 text-lg font-semibold rounded-lg shadow-lg shadow-emerald-500/40 transition-all duration-300 hover:shadow-emerald-500/60 hover:scale-105"
            >
              Get Free Consultation
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button 
              size="lg" 
              variant="outline"
              onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
              className="border-2 border-emerald-400/50 text-white hover:bg-emerald-500/30 hover:border-emerald-400 px-8 py-6 text-lg font-semibold rounded-lg backdrop-blur-md transition-all duration-300 hover:scale-105"
            >
              View Services
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-3 gap-6 max-w-xl">
            <div className="flex items-center gap-3 text-white/90 hover-scale backdrop-blur-md bg-white/10 rounded-lg p-3 border border-white/10">
              <Shield className="w-8 h-8 text-emerald-400" />
              <div>
                <div className="font-bold text-lg">15+</div>
                <div className="text-sm text-gray-300">Years Experience</div>
              </div>
            </div>
            <div className="flex items-center gap-3 text-white/90 hover-scale backdrop-blur-md bg-white/10 rounded-lg p-3 border border-white/10">
              <Zap className="w-8 h-8 text-cyan-400" />
              <div>
                <div className="font-bold text-lg">99.9%</div>
                <div className="text-sm text-gray-300">Uptime SLA</div>
              </div>
            </div>
            <div className="flex items-center gap-3 text-white/90 hover-scale backdrop-blur-md bg-white/10 rounded-lg p-3 border border-white/10">
              <Headset className="w-8 h-8 text-emerald-400" />
              <div>
                <div className="font-bold text-lg">24/7</div>
                <div className="text-sm text-gray-300">Support</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent z-10"></div>
    </section>
  );
};

export default Hero;
